import React from 'react';
import history from '../../../modules/History';
import { Button, notification } from 'antd';
import ReactTable from 'react-table'
import { getLuckyWheelCoupons } from '../../../modules/Api';
import ACL from '../../../components/ACL';

const btnStyle = {
    color: '#fff',
    borderRadius: '4px',
    padding: '8px',
    cursor: 'pointer',
    margin: '0 2px',
    width: '75px',
    display: 'inline-block',
    marginTop: '-5px',
    marginBottom: '-5px',
}
  
class LuckyWheelCoupons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            lucky_wheel_id: props.match.params.lucky_wheel_id,
            pageSize: 10,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const id = this.state.lucky_wheel_id;
        getLuckyWheelCoupons(id, (res) => {
            this.setState({items: res, count: res.length, pageSize: res.length});
        });
    }

    onChange(state) {

    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                filterable: false,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: false,
                Cell: (row) => (<ACL component="span" has_permission="lucky_wheels_management|lucky_wheels_edit" denied={() => {return row.original.title + " " + row.original.content;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}}
                                      title={row.original.action} onClick={() => {
                                      history.item.push(`/lucky_wheels/coupons/${this.state.lucky_wheel_id}/edit/${row.original.id}`)}
                                      }> {row.original.title + " " + row.original.content} </span></ACL>)
            },
            {
                Header: 'ترتیب نمایش',
                accessor: 'priority',
                filterable: false,
                Cell: (row) => (<span>{row.original.priority}</span>)
            }
        ];


        return (
            <div style={{textAlign: 'center'}}>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}


export default LuckyWheelCoupons;


// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/Coupons/index.js